export const INTERNAL_EMAIL_DOMAIN = '@gov.bc.ca';
